import Swiper, { Navigation, Autoplay } from 'swiper'
import 'swiper/css'
import { measures } from 'config/globals'

export default (config, context) => {
  const root = context.$root
  const prevEl = context.$refs['nav-prev']
  const nextEl = context.$refs['nav-next']
  const controls = root.closest('[data-slider-controls]')
  const arrows = root.querySelectorAll('[data-slider-arrow]')
  const { showOffsetBefore, containerSelector, ...additionalConfig } = config

  if (showOffsetBefore) {
    additionalConfig.breakpoints = {
      ...additionalConfig.breakpoints,
      '1100': {
        ...additionalConfig?.breakpoints?.['1100'],
        ...getOffset(containerSelector, showOffsetBefore, root),
      }
    }
  }

  const instance = new Swiper(root, {
    modules: [Navigation, Autoplay],
    pauseOnMouseEnter: true,
    preventInteractionOnTransition: true,
    ...((nextEl && prevEl) && {
      navigation: {
        disabledClass: 'pointer-events-none opacity-0',
        nextEl,
        prevEl,
      }
    }),
    ...additionalConfig,
  })
  context.instance = instance
  context.pause = () => {
    if (instance.autoplay.running) instance.autoplay.stop()
  }
  context.resume = () => {
    if (!instance.autoplay.running) instance.autoplay.start()
  }
  context.slideNext = () => {
    instance.slideNext()
  }
  context.slidePrev = () => {
    instance.slidePrev()
  }

  // root.addEventListener('click', (e) => {
  //   const { target } = e
  //   if (target.closest('[data-slider-arrow-trigger]')) {
  //     context.instance.slideNext()
  //     e.preventDefault()
  //     e.stopPropagation()
  //   }
  // })

  if (arrows.length) {
    arrows.forEach(elem => {
      const arrowWrap = document.createElement('button')
      arrowWrap.innerHTML = `<svg class="block mt-auto ico ico--chevron-r" width="13" height="22"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-chevron-r"></use></svg>`
      arrowWrap.dataset.sliderArrowTrigger = ''
      arrowWrap.classList.add('pointer-events-none', 'absolute', 'top-0', 'right-0', 'h-full', 'flex', 'px-6', 'py-4', 'bg-blue-base', 'bg-opacity-60', 'text-white', 'transition-opacity', 'opacity-0', 'lg:group-hover:opacity-100')

      elem.appendChild(arrowWrap)
    })
  }

  if (controls) {
    controls.querySelectorAll('[data-slider-control]').forEach((control) => {
      let controlInnerWrap = null
      let controlWrapInnerClasses = ['flex', 'justify-end', 'text-gray-60']
      let markup = `
        <button data-slider-prev class="relative text-blue-base focus:outline-none">
          <div class="absolute inset-0 -m-3"></div>
          <svg class="ico ico--arrow-l" width="32" height="10"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-l"></use></svg>
        </button>
      `
      const type = control.dataset.sliderControl
      const sliderCounts = getSliderCounts(instance)

      switch (type) {
        case 'paginated':
          controlWrapInnerClasses = [...controlWrapInnerClasses, 'space-x-4']
          if (sliderCounts.total > 0) {
            markup += `<div class="flex divide-x divide-gray-60">
              <span class="text-blue-base px-2" data-slider-current>${
                sliderCounts.current + 1
              }</span>
              <span class="px-2" data-slider-total>${
                sliderCounts.total
              }</span>
            </div>`
          }
          break

        default:
          controlWrapInnerClasses = [...controlWrapInnerClasses, 'space-x-10']
          break
      }

      markup += `
        <button data-slider-next class="relative text-blue-base focus:outline-none">
          <div class="absolute inset-0 -m-3"></div>
          <svg class="ico ico--arrow-r" width="32" height="10"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-r"></use></svg>
        </button>
      `

      controlInnerWrap = document.createElement('div')
      controlInnerWrap.innerHTML = markup
      controlWrapInnerClasses = [...controlWrapInnerClasses, 'pt-4']
      controlInnerWrap.classList.add(...controlWrapInnerClasses)
      
      control.appendChild(controlInnerWrap)
    })

    const adjustAllControls = () => {
      const { isBeginning, isEnd } = instance
      const sliderCounts = getSliderCounts(instance)

      controls
        .querySelectorAll('[data-slider-prev]')
        .forEach((root) => root.classList.toggle('opacity-40', isBeginning))
      controls
        .querySelectorAll('[data-slider-next]')
        .forEach((root) => root.classList.toggle('opacity-40', isEnd))
      controls
        .querySelectorAll('[data-slider-current]')
        .forEach((root) => (root.innerText = sliderCounts.current + 1))
      controls
        .querySelectorAll('[data-slider-total]')
        .forEach((root) => (root.innerText = sliderCounts.total))
    }

    adjustAllControls()

    instance.on('transitionEnd', () => {
      adjustAllControls()
    })
    // instance.on('update', () => {
    //   adjustAllControls()
    // })

    controls.addEventListener('click', (e) => {
      let shouldPreventDefault = false
      const { target } = e

      if (target.closest('[data-slider-prev]')) {
        shouldPreventDefault = true
        context.slidePrev()
      }
      if (target.closest('[data-slider-next]')) {
        shouldPreventDefault = true
        context.slideNext()
      }
      if (shouldPreventDefault) e.preventDefault()
    })
  }

  // listeners
  if (showOffsetBefore) {
    try {
      new ResizeObserver(() => {
        context.instance.params.breakpoints = {
          ...context.instance.params.breakpoints,
          '1100': {
            ...context.instance.params?.breakpoints?.['1100'],
            ...getOffset(containerSelector, showOffsetBefore, root),
          }
        }
        context.instance.update()
      }).observe(containerSelector ? root.closest(containerSelector) : window)
    } catch (error) {
      // no resize observer possible
      context.instance.on('resize', () => {
        context.instance.params.breakpoints = {
          ...context.instance.params.breakpoints,
          '1100': {
            ...context.instance.params?.breakpoints?.['1100'],
            ...getOffset(containerSelector, showOffsetBefore, root),
          }
        }
        context.instance.update()
      })
    }
  }

  // needed for links to work correctly in sliders
  const preventSlideOnLink = e => {
    !e.target.closest('img') && e.stopPropagation()
  }
  ['touchstart','mousedown','MSPointerDown','pointerdown'].forEach(event => {
    root.querySelectorAll('a').forEach(link => link.addEventListener(event, preventSlideOnLink))
  })
}

const getSliderCounts = (instance) => {
  let current
  const slidesLength = instance.slides.length
  const total = instance.params.loop
    ? Math.ceil(
        (slidesLength - instance.loopedSlides * 2) /
          instance.params.slidesPerGroup
      )
    : instance.snapGrid.length
  if (instance.params.loop) {
    current = Math.ceil(
      (instance.activeIndex - instance.loopedSlides) /
        instance.params.slidesPerGroup
    )
    if (current > slidesLength - 1 - instance.loopedSlides * 2) {
      current -= slidesLength - instance.loopedSlides * 2
    }
    if (current > total - 1) current -= total
    if (current < 0 && instance.params.paginationType !== 'bullets')
      current = total + current
  } else if (typeof instance.snapIndex !== 'undefined') {
    current = instance.snapIndex
  } else {
    current = instance.activeIndex || 0
  }

  return { current, total }
}

const getOffset = (container, showOffsetBefore, root) => {
  let outerWith
  if (typeof container === 'string') outerWith = root.closest(container)?.getBoundingClientRect()?.width
  else outerWith = window.innerWidth
  return {
    slidesOffsetBefore: Math.max(20, ((outerWith || 0) - (measures.row[showOffsetBefore] + 20)) / 2),
    slidesOffsetAfter: 20
  }
}